import React from "react";

const config = {
  ROMS: {
    corgssim: {
      name: "CORGS Simulator (U)",
      description: "A Retro Video Game Convention Simulator",
      url: "/roms/corgssim.nes",
    },
  },
  GOOGLE_ANALYTICS_CODE: process.env.REACT_APP_GOOGLE_ANALYTICS_CODE,
  SENTRY_URI: process.env.REACT_APP_SENTRY_URI,
};

export default config;
